import { useState } from "react";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import { Box, Container, styled } from "@mui/material";
import { Breadcrumbs } from "./Breadcrumbs";
import { Bar, BarItem } from "./HeaderBars";
import { PoweredByShape } from "./PoweredByShape";
import { HeaderProps } from "./types";
import { UserMenu } from "./UserMenu";
import { Tabs } from "../index";
import SideMenuTree, {
  DEFAULT_SIDEBAR_WIDTH,
} from "../SideMenuTree/SideMenuTree";
import React from "react";
import ProductsMenu from "../ProductsMenu/ProductsMenu";

const Header = ({
  breadcrumb,
  tabs,
  children,
  maxWidth,
  userMenu,
  isPoweredByShape = true,
  menuTree,
  placeholderText,
  showProductsMenu = false,
  productsMenuActiveItem,
  initialActiveItemId,
}: HeaderProps) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  return (
    <Box
      className={`header ${isSidebarOpen ? "sidebar-opened" : ""}`}
      id="page-header"
    >
      <StyledContainer
        maxWidth={maxWidth}
        sx={{
          px: { xs: 1, sm: 2, md: 4 },
          maxWidth: "100vw",
          ">*": {
            transition: "all 200ms ease",
            paddingLeft: isSidebarOpen ? DEFAULT_SIDEBAR_WIDTH : "",
          },
        }}
      >
        <Bar height="32px">
          <BarItem>
            {children} {isPoweredByShape && <PoweredByShape />}
          </BarItem>
          <div style={{ display: "flex", alignItems: "center", gap: "1.5rem" }}>
            <UserMenu {...userMenu} />
            {showProductsMenu && (
              <ProductsMenu productsMenuActiveItem={productsMenuActiveItem} />
            )}
          </div>
        </Bar>
        <Bar height="44px">
          {!isSidebarOpen && menuTree && (
            <MenuRoundedIcon
              sx={{
                ml: -1,
                mr: 1,
                p: 1,
                boxSizing: "content-box",
                fontSize: "21px",
                transform: "translateY(-1px)",
                cursor: "pointer",
                transition: "all 200ms ease-out",
                fill: "#999999",
              }}
              onClick={() => setIsSidebarOpen(!isSidebarOpen)}
            />
          )}
          {menuTree && (
            <SideMenuTree
              isSidebarOpen={isSidebarOpen}
              {...menuTree}
              onCloseSidebar={() => setIsSidebarOpen(false)}
              placeholderText={placeholderText ?? "Search..."}
              activeItemId={initialActiveItemId}
            />
          )}
          <StyledWrapper>
            {breadcrumb && breadcrumb.length > 0 && (
              <Breadcrumbs trail={breadcrumb} />
            )}

            {!!tabs && (
              <Box sx={{ width: "100%" }}>
                <Tabs {...tabs} />
              </Box>
            )}
          </StyledWrapper>
        </Bar>
      </StyledContainer>
    </Box>
  );
};

export default Header;
const StyledContainer = styled(Container)(({ theme }) => ({
  backgroundColor: theme.tokens.colors.gray[1],
  paddingTop: "16px",
}));
const StyledWrapper = styled(Box)({
  display: "grid",
  gridTemplateColumns: "1fr max-content",
  width: "100%",
  alignItems: "end",
  height: "100%",
  gap: "1rem",
});
